import { injectGlobal, keyframes } from 'styled-components'

const transitionClassName = 'slideright'
const duration = 450

const slideOut = keyframes`
	0% { transform: translateY(0); }
	25% { opacity: .5; }
	75% { opacity: .5; transform: translateX(200%); }
	100% { opacity: 0; transform: translateX(200%); }
`
const slideIn = keyframes`
	0% { transform: translateY(0); opacity: 0; }
	25% { opacity: .5; transform: translateX(-200%); }
	75% { opacity: .5; }
	100% { opacity: 1; transform: translateX(0); }
`

injectGlobal`
	.${transitionClassName}-exit-active {
  		animation: ${slideOut} ${duration}ms both ease-in;
	}
	.${transitionClassName}-enter-active {
  		animation: ${slideIn} ${duration}ms both ease;
	}
`

export default { transition: transitionClassName, duration }